<header class="sub-page-layout__header pointOfOrigin__header">
  <div class="pointOfOrigin__header-text h2 h2--semi-bold">Point Of Origin Codes</div>
  <mat-slide-toggle
    class="pointOfOrigin__active-toggle"
    [checked]="activeFilter === 'active'"
    color="primary"
    (change)="showInactiveChanges($event)"
  >
    <div *ngIf="activeFilter !== 'inactive'">Active</div>
    <div *ngIf="activeFilter === 'inactive'">Inactive</div>
  </mat-slide-toggle>
  <button mat-flat-button color="primary" class="pointOfOrigin__add-item" (click)="uploadCodes()" *ngIf="!viewOnly">
    <mat-icon>file_upload</mat-icon> Upload Point Of Origin Codes
  </button>
  <button
    mat-flat-button
    color="primary"
    class="pointOfOrigin__add-item"
    (click)="addPointOfOrigin()"
    *ngIf="!viewOnly"
  >
    <mat-icon>add_circle_outline</mat-icon> Add Point Of Origin Code
  </button>
</header>
<div *ngIf="dataSource && gridConfig" class="lib-grid__grid-container">
  <lib-grid [dataSource]="dataSource" [gridConfiguration]="gridConfig" skipLoadOnInit="true" loadAfterInit="true">
    <div class="">
      <h4>No Point Of Origin Codes Found.</h4>
    </div>
  </lib-grid>
</div>
<footer *ngIf="isImplementation" class="pointOfOrigin__footer">
  <lib-button-loading color="primary" class="pointOfOrigin__button" (clickEvent)="next()" id="nextButton"
    >Next
  </lib-button-loading>
</footer>
